import React from 'react';
import ReactPlayer from 'react-player'
import {connect} from "react-redux";
import {withRouter} from 'react-router-dom';

import {NoRecord} from 'components/common/app';
import {CardContainer, Input, Button, Tab, Image, Player, IconButton, ConfirmDialog} from 'components/common/uiKit';

import {serverUrl, apiUrl} from 'services/network';
import {LessonApi} from 'services/network/api'

class MainLesson extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            lessonId: 0,
            title: '',
            data: [],
            showConfirmDialog: false,
            selectedId: 0,
            deleteConfirmLoading: false
        };
    }

    componentDidMount() {
        this.linkProps()
    }

    linkProps() {
        const {lessonId, title, details} = this.props;
        this.setState({lessonId, data: details, title});
    }

    handleAddOnClick = () => {
        const {history} = this.props;
        const {lessonId} = this.state;

        history.push({
            pathname: `lessonDetail?type=add&lessonId=${lessonId}`,
            //search: `?lessonId=${id}`,
            //state: {type: 'add', lessonId: 12}
        });
    };

    handleEditOnClick = id => () => {
        const {history} = this.props;

        history.push({
            pathname: `lessonDetail?type=edit&id=${id}`,
            //search: `?lessonId=${id}`,
            //state: {type: 'add', lessonId: 12}
        });
    };

    handleDeleteOnClick = id => () => {
        this.setState({showConfirmDialog: true, selectedId: id});
    };

    handleDeleteConfirm = () => {
        const {selectedId} = this.state;
        if (selectedId) {
            this.setState({deleteConfirmLoading: true});

            LessonApi.DeleteDetail(selectedId)
                .then(res => {
                    if (res && res.status == 200) {
                        const {history} = this.props;
                        history.go(0);
                    }
                }).finally(() => {
                this.setState({deleteConfirmLoading: false});
            })
        }
    };

    handleDeleteCancel = () => {
        this.setState({showConfirmDialog: false, selectedId: 0});
    };

    handleSettingOnClick = () => {
        const {lessonId} = this.state;
        const {history} = this.props;
        history.push({
            pathname: `lessonSetting?id=${lessonId}`
        });
    };

    render() {
        const {data, title, showConfirmDialog, deleteConfirmLoading} = this.state;

        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.Admin.CMS.Lesson.Main;
        const confirmTranslates = locale.translation.Pages.Admin.CMS.Lesson.ConfirmDialog;

        return (
            <>
                <div className='m-3'>
                    <Button full type='success' shadowType='sm' onClick={this.handleAddOnClick}>
                        <i className='fa fa-plus font-weight-bold ml-2'/>
                        <span className='font-weight-bold font-14'>
                            {pageTranslates.Create}
                        </span>
                    </Button>
                </div>


                <CardContainer>
                    <div className='d-flex pb-2 align-items-center'>
                        <IconButton icon='cog' iconStyle={{fontSize: 13}} onClick={this.handleSettingOnClick}/>
                        <h3 className='color-primary mb-0'>
                            {title}
                        </h3>
                    </div>
                    {!data || data.length == 0 ?
                        <NoRecord message='MainLesson'/>
                        :
                        data.map(item => {
                            const content = item.content.split("\\n").map((text, i) => i ? [<br/>, text] : text);
                            const {id} = item;
                            switch (item.type) {
                                case 1:
                                    return (
                                        <div>
                                            <IconButton icon='pen' color='primary' iconStyle={{fontSize: 12}}
                                                        onClick={this.handleEditOnClick(id)}/>
                                            <IconButton icon='trash' iconStyle={{fontSize: 12, color: 'darkred'}}
                                                        onClick={this.handleDeleteOnClick(id)}/>
                                            <p className='font-13 list-bottom-separator pt-3 pb-3'
                                               style={{whiteSpace: 'pre-line'}}>
                                                {content}
                                            </p>
                                        </div>
                                    );
                                case 2:
                                    const image = serverUrl + content;
                                    return (
                                        <div>
                                            <IconButton icon='pen' color='primary' iconStyle={{fontSize: 12}}
                                                        onClick={this.handleEditOnClick(id)}/>
                                            <IconButton icon='trash' iconStyle={{fontSize: 12, color: 'darkred'}}
                                                        onClick={this.handleDeleteOnClick(id)}/>
                                            <div className='list-bottom-separator pt-2  pb-2'>
                                                <Image src={image}
                                                       style={{width: '100%', height: '100%', borderRadius: 20}}/>
                                            </div>
                                        </div>
                                    );
                                case 3:
                                    const url = `${apiUrl}/Media/Get?address=${content}`;

                                    return (
                                        <div>
                                            <IconButton icon='pen' color='primary' iconStyle={{fontSize: 12}}
                                                        onClick={this.handleEditOnClick(id)}/>
                                            <IconButton icon='trash' iconStyle={{fontSize: 12, color: 'darkred'}}
                                                        onClick={this.handleDeleteOnClick(id)}/>
                                            <Player url={url}/>
                                        </div>
                                    );
                            }
                        })
                    }
                </CardContainer>


                <ConfirmDialog open={showConfirmDialog} title={confirmTranslates.Title}
                               content={confirmTranslates.Content}
                               onAgree={this.handleDeleteConfirm} onCancel={this.handleDeleteCancel}
                               agreeLoading={deleteConfirmLoading}/>
            </>
        );
    }
}

const mapStateToProps = state => {
    const {locale} = state;
    return {locale};
};

export default connect(mapStateToProps, null)(withRouter(MainLesson));
